import React from 'react';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Notification,
  Message,
  IconWithText,
  FormikInput
} from '../../web.common';
import { sentenceCase } from 'change-case';
import CreatableArea from '../misc/CreatableArea';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import { getApiErrorMessage } from '../../common/utils';
import withApi from '../higherOrderComponents/withApi';
import { Divider, DetailsRightBar, NoLink } from './DetailsRightBar';

const guidSchema = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

class ParticipantInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };

    this.saveEditedParticipant = this.saveEditedParticipant.bind(this);
  }

  async onValidationError({ validateForm }) {
    const validationErrors = await validateForm();
    const fieldsWithError = Object.keys(validationErrors).map(x => sentenceCase(x)).join(', ');
    this.setState({
      apiResponse: new Message('error', `Unable to save. Check fields: ${fieldsWithError}`)
    });
  }

  saveEditedParticipant(receivedProps) {
    this.setState({ isLoading: true }, async () => {
      const {
        props: {
          language,
          history,
          api: {
            participants: {
              addParticipant
            }
          }
        }
      } = this;

      let updatedParticipantData = null;
      let apiResponse;

      try {
        updatedParticipantData = await addParticipant(receivedProps.values);
        apiResponse = new Message('success', 'Participant updated successfully');
      }
      catch (error) {
        console.log(error);
        apiResponse = getApiErrorMessage(error, language);

        this.setState({
          isLoading: false,
          apiResponse
        });

        return;
      }

      const { Id: participantId } = updatedParticipantData;
      history.push(`/participant/${participantId}`);
    });
  }

  isParticipantPublic(isPublic) {
    return (
      <IconWithText
        iconName={isPublic ? 'check' : 'times'}
        iconClasses={[`text-color-${isPublic ? 'success' : 'danger'}`]}
        text='Participant is public'
      />
    );
  }

  render() {
    const { isLoading, apiResponse } = this.state;

    const UserId = '';
    const PurchaseProductId = '';

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={apiResponse} />
            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='Participant page'
                documentDescription='Participant page'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Participant
              </h2>
              <h5 className='main-page-subheader'><i>New Participant</i></h5>
              <br />

              <CreatableArea
                ariaEditorName='editor-name'
                onSubmit={receivedProps => this.saveEditedParticipant(receivedProps)}
                isLoading={isLoading}
                savingText='Updating...'
                displayButtonLabels
                onValidationError={formikProps => this.onValidationError(formikProps)}
                validationSchema={Yup.object().shape({
                  UserId: Yup.string().matches(guidSchema, 'Field is mandatory'),
                  PurchaseProductId: Yup.string().matches(guidSchema, 'Field is mandatory')
                })}
                initialValues={{
                  UserId,
                  PurchaseProductId
                }}
              >
                <React.Fragment>
                  <DataDefinitionList
                    classNames={['border-0', 'detail-page-list']}
                    listData={[{
                      'User Id*': <FormikInput name='UserId' description='UserId' placeholder required />,
                      'Purchase Product Id*':
  <FormikInput name='PurchaseProductId' description='PurchaseProductId' placeholder required />
                    }]}
                    hasWideDescriptions
                  />
                </React.Fragment>
              </CreatableArea>
              <DetailsRightBar>
                <Divider>Links</Divider>
                <NoLink>None</NoLink>
                <Divider>Actions</Divider>
                <NoLink>None</NoLink>
              </DetailsRightBar>
            </div>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}
const ParticipantAdd = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(ParticipantInternal)
));

ParticipantAdd.requiresLogin = true;
ParticipantAdd.propTypes = { isLoggedIn: PropTypes.bool };

export default ParticipantAdd;